import styled from 'styled-components'

import * as breakpoint from '../constants/breakpoints'
import * as color from '../constants/colors'
import * as sizes from '../constants/sizes'

import * as accordion from './accordion'
import * as button from './button'
import * as checkbox from './form/checkbox'
import * as field from './form/field'
import * as filterValue from './tag'
import * as icons from '../svg/icons'

export const AccordionWrapper = styled.div`
  margin-bottom: 10px;

  ${field.Wrapper} {
    width: auto;
    transition: background-color 0.3s ease;
    position: relative;

    &:hover {
      background-color: ${color.SAND_3};
    }

    label {
      padding-left: 25px;
      padding-right: 44px;
    }
  }

  ${checkbox.Wrapper} {
    position: absolute;
    right: 20px;
  }

  ${icons.ChevronRight} {
    display: none;
  }

  @media not screen and (${breakpoint.MOBILE_L}) {
    position: relative;

    ${accordion.Content} {
      background-color: ${color.SAND_1};
      height: 100vh;
      left: 0;
      position: fixed;
      top: ${sizes.HEADER_MOBILE_INTERNAL_HEIGHT};
      width: 100vw;
      z-index: 1;
    }

    ${icons.ChevronDown} {
      display: none;
    }

    ${icons.ChevronRight} {
      display: block;
      position: absolute;
      right: 8px;
      top: 14px;
      pointer-events: none;
    }
  }
`

export const TagList = styled.div`
  margin-top: 12px;
  padding: 0 18px;

  ${filterValue.Wrapper} {
    margin-right: 10px;
    margin-bottom: 5px;
  }

  @media screen and (${breakpoint.TABLET}) {
    padding: 0;
  }
`

export const Back = styled(button.UnstyledButton)`
  align-items: center;
  cursor: pointer;
  display: none;
  margin-bottom: 25px;
  margin-top: 25px;
  padding-left: 25px;
  width: 100%;

  ${icons.ChevronLeft} {
    margin-right: 20px;
  }

  @media not screen and (${breakpoint.MOBILE_L}) {
    display: flex;
  }
`

export const ContentListWrapper = styled.div``

export const List = styled.div`
  @media not screen and (${breakpoint.MOBILE_L}) {
    max-height: 64vh;
    overflow: auto;
  }
`
